module.exports = __webpack_public_path__ + "img/logo-presse-alliancy_200x200.517ca326.jpg";